import { MdrCustomerPanelController } from '../controller/MdrCustomerPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MdrCustomerPanelWebComponent extends BaseWebComponentElement {
  controller: MdrCustomerPanelController;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MdrCustomerPanelController,
    });
  }
}
